import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#3A3A3A] pt-[80px] pb-[40px] px-6 text-white" data-id="element-68">
      <div className="max-w-[1200px] mx-auto" data-id="element-69">
        {/* 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-70">
          {/* Column 1 — Important Information */}
          <div data-id="element-71">
            <h4 className="text-[14px] font-optima font-semibold uppercase tracking-[0.1em] text-white mb-6" data-id="element-72">
              Important Information
            </h4>
            <p className="text-[16px] font-optima text-white/70 leading-[1.6]" data-id="element-73">
              It is an offence to sell or supply alcohol to, or to obtain
              alcohol on behalf of, a person under the age of 18 years.
            </p>
            <div className="flex space-x-5 mt-10" data-id="element-74">
              <a href="#" className="text-white/70 hover:text-gold transition-colors duration-300" data-id="element-75">
                <Facebook className="w-6 h-6" data-id="element-76" />
              </a>
              <a href="#" className="text-white/70 hover:text-gold transition-colors duration-300" data-id="element-77">
                <Instagram className="w-6 h-6" data-id="element-78" />
              </a>
            </div>
          </div>

          {/* Column 2 — Customer Care */}
          <div data-id="element-79">
            <h4 className="text-[14px] font-optima font-semibold uppercase tracking-[0.1em] text-white mb-6" data-id="element-80">
              Customer Care
            </h4>
            <ul className="space-y-4" data-id="element-81">
              {['About', 'Wines', 'Sustainability', 'Contact', 'Privacy Policy', 'Terms & Conditions'].map(item => <li key={item} data-id="element-82">
                  <a href="#" className="text-[16px] font-optima text-white/80 hover:text-gold transition-colors duration-300" data-id="element-83">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3 — Newsletter */}
          <div data-id="element-84">
            <h4 className="text-[14px] font-optima font-semibold uppercase tracking-[0.1em] text-white mb-6" data-id="element-85">
              Newsletter
            </h4>
            <p className="text-[16px] font-optima text-white/80 leading-[1.6]" data-id="element-86">
              Subscribe to receive updates, access to exclusive deals, and more.
            </p>
            <div className="mt-10" data-id="element-87">
              <input type="email" placeholder="Enter your email address" className="w-full h-[50px] px-4 bg-transparent border border-white text-white text-[16px] font-optima placeholder:text-white/50 focus:outline-none focus:border-gold transition-colors duration-300" data-id="element-88" />
              <button className="mt-4 bg-[#4A4A4A] text-white text-[14px] font-optima font-semibold uppercase tracking-[0.1em] px-8 py-[14px] hover:bg-gold transition-colors duration-300" data-id="element-89">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 mt-10 pt-8" data-id="element-90">
          <p className="text-center text-[14px] font-optima text-white/60" data-id="element-91">
            © 2026 Glenlofty Estate. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}